import React, { useState } from 'react';
import ActiveBonusTrades from './ActiveBonusTrades';
import CompletedBonusTrades from './CompletedBonusTrades'
import BonusTrades from './BonusTrades';
import { Link } from 'react-router-dom'
import SneakPeek from './SneakPeek.js'
import Drawer from '@mui/material/Drawer';
import LaunchIcon from '@mui/icons-material/Launch';
import ActiveTradesDrawer from '../trades/ActiveTradesDrawer.js';

function BonusTradesOverview(props) {

    let brokerage = props.brokerageConnections && props.brokerageConnections.length ? "schwab" : null
    const [updates, setUpdates] = useState(0);
    const [sneakPeekOpen, setSneakPeekOpen] = useState(false);

    function onUpdate() {
        console.log("BonusTradesOverview onUpdate", updates);
        setUpdates(updates + 1);
    }

    const planId = 108;

    return (
        <div>
            <h4>Trade Feed</h4>
            <Link className="drawer-link" onClick={() => setSneakPeekOpen(true)}>Take a sneak peek <LaunchIcon fontSize='small' /></Link>
            <br></br>
            <BonusTrades updates={updates} onUpdate={onUpdate} showAll={false} mobileView={props.mobileView} userId={props.userId} accountValue={props.accountValue} brokerage={brokerage} accountId={props.accountId} />
            <br></br>
            <hr></hr>
            <h4>Active Trades</h4>
            <ActiveTradesDrawer link={"See All Active Bonus Trades"} hideCharts={true} onlyShowUserTrades={false} userId={props.userId} accountId={props.accountId} planId={planId} mobileView={true} accountValue={props.accountValue} role={props.role} />

            <ActiveBonusTrades updates={updates} onUpdate={onUpdate} hideCharts={false} onlyShowUserTrades={true} planId={108} userId={props.userId} accountId={props.accountId} mobileView={props.mobileView} onAlgoSelected={props.onAlgoSelected} accountValue={props.accountValue} brokerage={brokerage} role={props.role} />
            <br></br>
            <hr></hr>
            <h4>Completed Trades</h4>
            <CompletedBonusTrades updates={updates} onUpdate={onUpdate} hideCharts={true} hideDateSelector={true} onlyShowUserTrades={true} planId={108} userId={props.userId} accountId={0} mobileView={props.mobileView} onAlgoSelected={props.onAlgoSelected} accountValue={props.accountValue} role={props.role} />

            <Drawer
                anchor={'left'}
                open={sneakPeekOpen}
                onClose={() => setSneakPeekOpen(false)}
            >
                <div style={{ width: 400, padding: '20px' }}>
                    <h4>Sneak Peek</h4>
                    <br></br>
                    <SneakPeek supressAllocations={true} planId={108} role={props.role} />
                    <br></br>
                    <center><Link onClick={() => setSneakPeekOpen(false)}>CLOSE</Link></center>
                </div>
            </Drawer>
        </div>
    );
}

export default BonusTradesOverview;